import { Routes } from '@angular/router';
import { LayoutBaseComponent } from './core/layout-base/layout-base.component';
import { adminAuthGuard } from './shared/guards/admin-auth.guard';

export const routes: Routes = [
  {
    path: 'login',

    loadChildren: () =>
      import('./auth/login/login.routes').then((m) => m.LOGIN_ROUTES),
  },

  {
    path: '',
    component: LayoutBaseComponent,
    canActivate: [adminAuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES
          ),
      },
      {
        path: 'imports',
        loadChildren: () =>
          import('./pages/imports/imports.routes').then((m) => m.IMPORT_ROUTES),
      },
      {
        path: 'mile-express-wms',
        loadChildren: () =>
          import('./pages/warehouse/warehouse.routes').then(
            (m) => m.WAREHOUSE_ROUTES
          ),
      },
      {
        path: 'export',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('./pages/export/export.routes').then((m) => m.EXPORT_ROUTES),
          },
          {
            path: 'devolution-siscomex',
            loadChildren: () =>
              import('./pages/export/devolution-siscomex/devolution-siscomex.routes').then(
                (m) => m.DEVOLUTION_SISCOMEX_ROUTES
              ),
          },
        ],
      },
      {
        path: 'post-office',
        loadChildren: () =>
          import('./pages/post-office/post-office.routes').then(
            (m) => m.POST_OFFICE_ROUTES
          ),
      },
      {
        path: 'last-mile',
        loadChildren: () =>
          import('./pages/last-mile/last-mile.routes').then(
            (m) => m.LAST_MILE_ROUTES
          ),
      },
      {
        path: 'importers',
        loadChildren: () =>
          import('./pages/importers/imports.routes').then(
            (m) => m.IMPORTERS_ROUTES
          ),
      },
      {
        path: 'shippers',
        loadChildren: () =>
          import('./pages/shippers/shippers.routes').then(
            (m) => m.SHIPPERS_ROUTES
          ),
      },
      {
        path: 'companies',
        loadChildren: () =>
          import('./pages/companies/companies.routes').then(
            (m) => m.COMPANIES_ROUTES
          ),
      },
      {
        path: 'airports',
        loadChildren: () =>
          import('./pages/airports/airports.routes').then(
            (m) => m.AIRPORTS_ROUTES
          ),
      },
      {
        path: 'bank-files',
        loadChildren: () =>
          import('./pages/bank-files/bank-files.routes').then(
            (m) => m.BANK_FILES_ROUTES
          ),
      },
      {
        path: 'financial',
        loadChildren: () =>
          import('./pages/financial/financial.routes').then(
            (m) => m.FINANCIAL_ROUTES
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES
          ),
      },
      {
        path: 'configuration/notification-type',
        loadChildren: () =>
          import('./pages/notification-type/notification-type.routes').then(
            (m) => m.NOTIFICATION_TYPE_ROUTES
          ),
      },
      {
        path: 'romanians',
        loadChildren: () =>
          import('./pages/romanians/romanians.routes').then(
            (m) => m.ROMANIANS_ROUTES
          ),
      },
      {
        path: 'process',
        children: [
          {
            path: 'notifications',
            loadChildren: () =>
              import('./pages/notifications/notifications.routes').then(
                (m) => m.NOTIFICATIONS_ROUTES
              ),
          },
          {
            path: 'rpa',
            loadChildren: () =>
              import('./pages/rpa/rpa.routes').then(
                (m) => m.RPA_ROUTES
              ),
          },
          {
            path: 'rpa-schedule',
            children: [
              {
                path: 'create',
                loadComponent: () =>
                  import('./pages/rpa/components/schedule-create/schedule-create.component').then(
                    (m) => m.ScheduleCreateComponent
                  ),
              },
              {
                path: 'edit/:id',
                loadComponent: () =>
                  import('./pages/rpa/components/schedule-create/schedule-create.component').then(
                    (m) => m.ScheduleCreateComponent
                  ),
              },
              {
                path: 'show/:id',
                loadComponent: () =>
                  import('./pages/rpa/components/schedule-view/schedule-view.component').then(
                    (m) => m.ScheduleViewComponent
                  ),
              },
            ],
          },
          {
            path: 'message-log',
            loadChildren: () =>
              import('./pages/message-log/message-log.routes').then(
                (m) => m.MESSAGE_LOG_ROUTES
              ),
          },
          {
            path: 'checkpoints-lote',
            loadChildren: () =>
              import('./pages/checkpoints-lote/checkpoints-lote.routes').then(
                (m) => m.CHECKPOINTS_LOTE_ROUTES
              ),
          },
          {
            path: 'checkpoints-process',
            loadChildren: () =>
              import('./pages/checkpoints-process/checkpoints-process.routes').then(
                (m) => m.CHECKPOINTS_PROCESS_ROUTES
              ),
          },
        ],
      },
      {
        path: 'airwaybill-storage',
        loadChildren: () =>
          import('./pages/airwaybill-storage/airwaybill-storage.routes').then(
            (m) => m.AIRWAYBILL_STORAGE_ROUTES
          ),
      },
      {
        path: 'checkin',
        loadChildren: () =>
          import('./pages/imports/checkin/checkin-routers').then(
            (m) => m.CHECKIN_ROUTES
          ),
      },
      {
        path: 'manga',
        loadChildren: () =>
          import('./pages/airwaybill-storage/airwaybill-storage.routes').then(
            (m) => m.AIRWAYBILL_STORAGE_ROUTES
          ),
      },
      /** Compatível com mile-system-client (`/busca-remessa`). */
      {
        path: 'busca-remessa',
        redirectTo: 'process/rpa/pesquisar-remessas',
        pathMatch: 'full',
      },
      /** Compatível com mile-system-client (`/checkin-tools`). */
      {
        path: 'checkin-tools',
        redirectTo: 'imports/checkin/tools',
        pathMatch: 'full',
      },
      /** Compatível com mile-system-client (`/checkin-import-transport`). */
      {
        path: 'checkin-import-transport',
        redirectTo: 'imports/checkin/import-transport',
        pathMatch: 'full',
      },
      /** Compatível com mile-system-client (`/checkin-resumo`). */
      {
        path: 'checkin-resumo',
        redirectTo: 'imports/checkin/resumo',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
